module.exports = __webpack_public_path__ + "c0a07c25ae4bc6df15df45a4ee73e2b2.svg";